<template>
  <div>
    <section>
      
      <!-- <div>Sheets: {{ sheets }}</div> -->

      <xlsx-workbook>
        <xlsx-sheet
          :collection="sheet.data"
          v-for="sheet in sheets"
          :key="sheet.name"
          :sheet-name="sheet.name"
          
        />
        <xlsx-download :filename="fname">
          <v-btn color="warning">Template</v-btn>
        </xlsx-download>
      </xlsx-workbook>
    </section>
  </div>
</template>

<script>
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx"

export default {
  props:['sheets','fname'],
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
   
  },
  data() {
    return {
      file: null,
      selectedSheet: null,
      sheetName: null,
    };
  },
  methods: {
    addSheet() {
      this.sheets.push({ name: this.sheetName, data: [...this.collection] });
      this.sheetName = null;
    }
  }
};
</script>